import { render, staticRenderFns } from "./CountsView.vue?vue&type=template&id=2aeef16e"
import script from "./CountsView.vue?vue&type=script&lang=js"
export * from "./CountsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports